import { useEffect, useState } from 'react';

const useEasterEgg = (targetSequence, callback) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handler = (event) => {
      if (event.key === targetSequence[currentIndex]) {
        if (currentIndex + 1 === targetSequence.length) {
          callback();
          setCurrentIndex(0);
        } else {
          setCurrentIndex(currentIndex + 1);
        }
      } else {
        setCurrentIndex(0);
      }
    };

    window.addEventListener('keydown', handler);
    return () => {
      window.removeEventListener('keydown', handler);
    };
  }, [currentIndex, callback, targetSequence]);
};

export default useEasterEgg;